import { useEffect } from 'react'

type OutsideclickProps = {
  containerRef: React.MutableRefObject<
    HTMLInputElement | HTMLDivElement | HTMLButtonElement | undefined
  >
  callback: (eventTarget?: HTMLElement) => void
}

const useOutsideOnClick = ({
  containerRef,
  callback,
}: OutsideclickProps): void => {
  const handleOutsideClick = (event) => {
    if (!containerRef.current || containerRef.current.contains(event.target)) {
      return
    }

    callback(event.target)
  }

  useEffect(() => {
    if (containerRef.current) {
      document.addEventListener('mousedown', handleOutsideClick)
      document.addEventListener('touchstart', handleOutsideClick)
    }

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick)
      document.removeEventListener('touchstart', handleOutsideClick)
    }
  }, [containerRef, callback])
}

export default useOutsideOnClick
